import { Inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '../../environments/environment';

/**
 * Intercepts HTTP calls and adds OKTA auth infos
 */
@Injectable({
  providedIn: "root"
})
export class OktaInterceptor implements HttpInterceptor {
  /**
   * Constructor
   * @param oktaAuth OKTA auth
   */
  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) { }

  /**
   * Intercepts HTTP calls and adds OKTA auth infos
   * @param req The request
   * @param next HttpHandler
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!environment.UseOkta) {
      //if not okta => do nothing
      return next.handle(req);
    }

    const normalizedEndpoint = req.url.toLowerCase().trim();//simplified "normalize" from azure-msal-angular
    if (!normalizedEndpoint.startsWith('http')) {
      return next.handle(req);
    }

    const protectedResourcesArray = Array.from(environment.AzureProtectedResourceMap.keys());
    const keyMatchesEndpointArray = protectedResourcesArray.filter(key => {
      const normalizedKey = key.toLowerCase().trim();
      return normalizedEndpoint.startsWith(normalizedKey);
    });
    if (keyMatchesEndpointArray.length === 0) {
      //resource is not protected
      return next.handle(req);
    }

    const idToken = this.oktaAuth.getIdToken();//JLL uses Okta id_token

    const authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${idToken}`)
    });

    return next.handle(authReq);
  }
}
